export interface ScoringCriterion {
  key: string;
  category: string;
  labelEs: string;
  labelIt: string;
  descriptionEs: string;
  descriptionIt: string;
  weight: number;
  enabled: boolean;
  appliesTo: 'both' | 'evaluate' | 'pitch';
  sortOrder: number;
}

export interface UpdateScoringCriterion {
  key: string;
  weight: number;
  enabled: boolean;
}

/** Etiqueta/descripción del criterio en el idioma de la UI. */
export function criterionLabel(c: ScoringCriterion, language: string): string {
  return language === 'it' ? c.labelIt : c.labelEs;
}

export function criterionDescription(c: ScoringCriterion, language: string): string {
  return language === 'it' ? c.descriptionIt : c.descriptionEs;
}
